import React from 'react';
import { useDispatch } from 'react-redux';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import Translation from '@swf/components/Translation/Translation';
import type { Dispatch } from '@swf/core/store';

import {
  TXTACL_Contact_us,
  TXTWCL_CanXt_find_what_youXre_looking_ELL
} from './ContactUs.messages.json';
import styles from './ContactUs.scss';

const ContactUs: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  return (
    <section className={styles.container}>
      <h3>
        <Translation {...TXTWCL_CanXt_find_what_youXre_looking_ELL} />
      </h3>
      <StarsButton
        translation={TXTACL_Contact_us}
        onClick={() => modal.enqueue({ path: `/help/contact` })}
      />
    </section>
  );
};

export default ContactUs;
